<template>
    <div class="auth">
        <div class="login" v-show="showLogin">
            <img @click="close" class="close" src="https://appd.knowbox.cn/ss/activity/group-buy/close-icon.png" alt="" srcset="">
            <p class="title">验证手机号</p>
            <div class="tel">
                <input type="number" placeholder="手机号" v-model="mobile">
            </div>
            <div class="vcode">
                <input type="number" placeholder="验证码" v-model="vcode">
                <img v-if="isSendVcode" src="https://appd.knowbox.cn/ss/activity/group-buy/loading.png" alt="" srcset="">
                <span v-else :class="[ mobile.length ==0 && 'active']"  @click="sendVcode">{{vcodeTxt}}</span>
            </div>
            <p class="error">{{error}}</p>
            <button class="verify" @click="verifyVcode">验证</button>
        </div>
        <div v-show="showGrade" class="select_grade">
            <img @click="close" class="close" src="https://appd.knowbox.cn/ss/activity/group-buy/close-icon.png" alt="" srcset="">
            <p class="title">选择你的年级</p>
            <ul>
                <li 
                  v-for="(item, index) in grades" 
                  :key="index" 
                  :class="index == currGrade ? 'active' : ''"
                  @click="selectGrade(index)"
                >{{item}}年级</li>
            </ul>
            <!-- <p class="tips">没有针对六年级同学的暑期计划</p> -->
            <button class="verify" @click="bindStudent">确定</button>
        </div>
    </div>
</template>

<script>
import utils from "@/assets/js/utils";

export default {
  name: "auth",
  data() {
    return {
      showLogin: true,
      showGrade: false,
      mobile: "",
      error: "",
      vcodeTxt: "获取验证码",
      vcode: "",
      reSend: true,
      grades: ["一", "二", "三", "四", "五", "六"],
      currGrade: -1,
      isSendVcode: false
    };
  },
  props: {
    version: String,
    channel: String,
    source: String
  },
  components: {},
  created: function() {},
  watch: {
    mobile() {
      this.mobile = this.mobile.substr(0, 11);
    },
    vcode() {
      this.vcode = this.vcode.substr(0, 4);
    }
  },
  methods: {
    sendVcode() {
      this.isSendVcode = true;
      if (!this.verifyMobile() || !this.reSend) {
        return;
      }
      const { source, version, mobile } = this;
      this.$api
        .sendVcode({
          version,
          source,
          mobile
        })
        .then(() => {
          this.countDown();
        })
        .catch(res => {
          this.$toast(res.msg);
        });
    },
    verifyMobile() {
      let reg = /^1[0-9]{10}$/;
      if (!reg.test(this.mobile)) {
        this.error = "请输入正确的手机号";
        return false;
      } else {
        this.error = "";
        return true;
      }
    },
    verifyVcode() {
      utils.sendLog(
        {
          token: "",
          version: this.version,
          source: this.source
        },
        "hzxx850"
      );
      if (!this.verifyMobile()) {
        return;
      }
      const { source, version, mobile, vcode, channel } = this;
      this.$api
        .loginGroupBuying({
          channel,
          version,
          source,
          mobile,
          code: vcode
        })
        .then(data => {
          localStorage.setItem("token", data.token);
          if (data.hasBind == 0) {
            this.showLogin = false;
            this.showGrade = true;
            utils.sendLog(
              {
                token: data.token,
                version: this.version,
                source: this.source
              },
              "hzxx851"
            );
          } else {
            localStorage.setItem("mobile", this.mobile);
            this.$emit("initData", true);
          }
        })
        .catch(res => {
          this.$toast(res.msg);
        });
    },
    countDown() {
      this.reSend = false;
      let count = 60;
      let timer = setInterval(() => {
        count--;
        this.vcodeTxt = count + "s";
        this.isSendVcode = false;
        if (count == 0) {
          this.vcodeTxt = "重新获取";
          this.reSend = true;
          clearInterval(timer);
        }
      }, 1000);
    },
    selectGrade(index) {
      this.currGrade = index;
    },
    bindStudent() {
      utils.sendLog(
        {
          token: localStorage.getItem("token"),
          version: this.version,
          source: this.source
        },
        "hzxx852"
      );
      if (this.currGrade == -1) {
        this.$toast("请选择年级");
        return;
      }
      const { source, version, channel } = this;
      this.$api
        .registerStudentAndBind({
          token: localStorage.getItem("token"),
          channel,
          version,
          source,
          sex: 2,
          username: "用户" + this.mobile.substr(0, 4),
          grade: this.currGrade + 1
        })
        .then(() => {
          localStorage.setItem("mobile", this.mobile);
          this.$emit("initData", true);
        })
        .catch(res => {
          this.$toast(res.msg);
        });
    },
    close() {
      this.$emit("close");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.auth {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba($color: #000000, $alpha: 0.5);
  .login,
  .select_grade {
    width: 5.8rem;
    height: 5.2rem;
    position: absolute;
    top: 50%;
    left: 50%;
    background: #fff;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    border-radius: 0.3rem;
    position: relative;
    .close {
      position: absolute;
      right: 0;
      top: 0;
      width: 0.63rem;
      height: 0.63rem;
    }
    .title {
      font-family: PingFangSC-Medium;
      font-size: 0.36rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.36rem;
      letter-spacing: 0px;
      color: #424243;
      text-align: center;
      padding-top: 0.5rem;
    }
    > div {
      margin-left: 0.49rem;
      width: 4.8rem;
      padding-top: 0.66rem;
      height: 1.2rem;
      border-bottom: 0.01rem solid #e9eaef;
      font-size: 0.3rem;
      input {
        height: 0.4rem;
        line-height: 0.4rem;
        font-family: PingFangSC-Medium;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #4a4b4c;
      }
    }
    .tel {
      input {
        width: 4.8rem;
      }
    }
    .vcode {
      display: flex;
      justify-content: space-between;
      input {
        width: 2.3rem;
        height: 0.4rem;
      }
      span {
        height: 0.4rem;
        line-height: 0.4rem;
        color: #43a4f3;
        &.active {
          color: #919294;
        }
      }
      img {
        width: 0.3rem;
        height: 0.3rem;
        -webkit-animation: spin 1s linear 1s 5 alternate;
        animation: spin 1s linear infinite;
      }
    }
    .error {
      position: absolute;
      width: 4.8rem;
      left: 0.5rem;
      bottom: 1.49rem;
      font-family: PingFangSC-Medium;
      font-size: 0.24rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.24rem;
      letter-spacing: 1px;
      color: #ff7575;
    }
    .verify {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1rem;
      background-color: #85cdf8;
      border-radius: 0px 0px 0.3rem 0.3rem;
      font-family: PingFangSC-Semibold;
      font-size: 0.32rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ffffff;
    }
  }
  .select_grade {
    height: 6.51rem;
    ul {
      padding-left: 0.42rem;
      padding-right: 0.42rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 0.51rem;
      li {
        width: 2.35rem;
        height: 0.89rem;
        margin-bottom: 0.33rem;
        text-align: center;
        line-height: 0.89rem;
        border-radius: 0.44rem;
        font-family: PingFangSC-Medium;
        font-size: 0.32rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        border: solid 0.02rem #bdbfc1;
        color: #5f6162;
        background: #fff;
        &.active {
          color: #ffffff;
          background-color: #85cdf8;
          border: solid 0.02px #85cdf8;
        }
      }
    }
    .tips {
      height: 0.28rem;
      width: 100%;
      text-align: center;
      font-size: 0.28rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.28rem;
      letter-spacing: 0px;
      color: #909193;
    }
  }
}
@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>